import { z } from 'zod';
export var FlowHumanTaskPrimitiveConditionOperation;
(function (FlowHumanTaskPrimitiveConditionOperation) {
    FlowHumanTaskPrimitiveConditionOperation["IsNullish"] = "IsNullish";
    FlowHumanTaskPrimitiveConditionOperation["IsDefined"] = "IsDefined";
    FlowHumanTaskPrimitiveConditionOperation["IsTruthy"] = "IsTruthy";
    FlowHumanTaskPrimitiveConditionOperation["IsFalsy"] = "IsFalsy";
})(FlowHumanTaskPrimitiveConditionOperation || (FlowHumanTaskPrimitiveConditionOperation = {}));
export const FlowHumanTaskPrimitiveConditionSchema = z.object({
    operation: z.enum(FlowHumanTaskPrimitiveConditionOperation),
    fieldName: z.string(),
});
export var FlowHumanTaskValueConditionOperation;
(function (FlowHumanTaskValueConditionOperation) {
    FlowHumanTaskValueConditionOperation["EqualsIgnoreCase"] = "EqualsIgnoreCase";
    FlowHumanTaskValueConditionOperation["NotEqualsIgnoreCase"] = "NotEqualsIgnoreCase";
})(FlowHumanTaskValueConditionOperation || (FlowHumanTaskValueConditionOperation = {}));
export const FlowHumanTaskValueConditionSchema = z.object({
    operation: z.enum(FlowHumanTaskValueConditionOperation),
    fieldName: z.string(),
    value: z.string(),
});
export var FlowHumanTaskArrayConditionOperation;
(function (FlowHumanTaskArrayConditionOperation) {
    FlowHumanTaskArrayConditionOperation["IsOneOf"] = "IsOneOf";
    FlowHumanTaskArrayConditionOperation["IsNotOneOf"] = "IsNotOneOf";
})(FlowHumanTaskArrayConditionOperation || (FlowHumanTaskArrayConditionOperation = {}));
export const FlowHumanTaskArrayConditionSchema = z.object({
    operation: z.enum(FlowHumanTaskArrayConditionOperation),
    fieldName: z.string(),
    values: z.array(z.string()),
});
export const FlowHumanTaskConditionSchema = z.discriminatedUnion('operation', [
    FlowHumanTaskPrimitiveConditionSchema,
    FlowHumanTaskValueConditionSchema,
    FlowHumanTaskArrayConditionSchema,
]);
export function isFlowHumanTaskValueCondition(condition) {
    return 'value' in condition;
}
export function isFlowHumanTaskArrayCondition(condition) {
    return 'values' in condition;
}
export function isFlowHumanTaskPrimitiveCondition(condition) {
    return !isFlowHumanTaskValueCondition(condition) && !isFlowHumanTaskArrayCondition(condition);
}
//# sourceMappingURL=conditional.js.map